import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Action
export const fetchDashboardFeeds = createAsyncThunk(
  "dashboard/fetchDashboardFeeds",
  async () => {
    // Replace the URL with your actual endpoint to fetch dashboard data
    // const response = await fetch("https://api.example.com/dashboard");
    // return response.json();

    await new Promise((resolve) => setTimeout(resolve, 2000));
    return {
      data: {
        feeds: [
          {
            title: "The system temperature now increased to 100 C.",
            date: "20 Oct 2023, 07:42 PM",
            sender: "Person Name",
          },
          {
            title: "The system temperature now increased to 100 C.",
            date: "20 Oct 2023, 07:42 PM",
            sender: "Person Name",
          },
          {
            title: "The system temperature now increased to 100 C.",
            date: "20 Oct 2023, 07:42 PM",
            sender: "Person Name",
          },
          {
            title: "The system temperature now increased to 100 C.",
            date: "20 Oct 2023, 07:42 PM",
            sender: "Person Name",
          },
          {
            title: "The system temperature now increased to 100 C.",
            date: "20 Oct 2023, 07:42 PM",
            sender: "Person Name",
          },
          {
            title: "The system temperature now increased to 100 C.",
            date: "20 Oct 2023, 07:42 PM",
            sender: "Person Name",
          },
        ],
      },
    };
  }
);

// Dashboard Slice
const dashboardSlice = createSlice({
  name: "dashboardFeeds",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDashboardFeeds.pending, (state) => {
      state.isLoading = true;
      state.isError = false;
    });
    builder.addCase(fetchDashboardFeeds.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchDashboardFeeds.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      console.error("Error fetching dashboard data:", action.error.message);
    });
  },
});

export default dashboardSlice.reducer;
